module.exports = __webpack_public_path__ + "media/images/gallery/constellations/hercules/her_vis-a7196dd680379a65c94a7fceb17431a7.jpg";